module.exports = __webpack_public_path__ + "static/bottom_right-d9962ab5ce21e2543828207b6d8e46af.png";